<script lang="ts">
interface Props {
    image?: { url: string; alt: string };
    squareImage?: { url: string; alt: string };
    metaDescription?: string;
    ogLanguage?: string;
    pageTitle?: string;
    siteTitle?: string;
    url?: string;
}

let { image, squareImage, metaDescription, ogLanguage, pageTitle, siteTitle, url }: Props =
    $props();
</script>

<svelte:head>
    <meta property="og:site_name" content={siteTitle} />
    <meta property="og:locale" content={ogLanguage} />
    <meta property="og:url" content={url} />
    <meta property="og:type" content="website" />
    <meta property="og:title" content={pageTitle} />
    <meta property="og:description" content={metaDescription} />
    {#if image}
        <meta property="og:image" content={image.url} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={image.alt} />
    {/if}
    {#if squareImage}
        <meta property="og:image" content={squareImage.url} />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="400" />
        <meta property="og:image:alt" content={squareImage.alt} />
    {/if}
</svelte:head>
